import { getEffectiveDayPlan } from '../data/plan'
import { computeDayNutrition } from './mealOverrides'

function isDayComplete(log, dayNumber, aiPlan) {
  const plan = getEffectiveDayPlan(dayNumber, aiPlan)
  return plan.exercises.length > 0 && plan.exercises.every((e) => log?.exerciseChecks?.[e.name])
}

// One recap per week (7-day block) from day 1 up to (and including) the
// current, possibly-partial week - only counting days that have actually
// elapsed, same "day complete" definition Progress.jsx already uses for
// adherence/streaks. Returned newest week first.
export function buildWeeklyReviews(logs, currentDay, aiPlan, exercisePRs) {
  const currentWeek = Math.floor((currentDay - 1) / 7) + 1
  const weeks = []

  for (let w = currentWeek; w >= 1; w--) {
    const startDay = (w - 1) * 7 + 1
    const endDay = Math.min(w * 7, currentDay - 1)
    if (endDay < startDay) continue

    const dayNumbers = []
    for (let d = startDay; d <= endDay; d++) dayNumbers.push(d)

    const completedDays = dayNumbers.filter((d) => isDayComplete(logs[String(d)], d, aiPlan)).length
    const adherence = dayNumbers.length ? Math.round((completedDays / dayNumbers.length) * 100) : 0

    const weights = dayNumbers.map((d) => logs[String(d)]?.weightKg).filter((v) => v != null)
    const weightChange = weights.length >= 2 ? Math.round((weights[weights.length - 1] - weights[0]) * 10) / 10 : null

    const nutritionDays = dayNumbers
      .map((d) => computeDayNutrition(d, logs[String(d)] || {}, aiPlan))
      .filter((n) => n.checkedKcal > 0)
    const avgKcal = nutritionDays.length ? Math.round(nutritionDays.reduce((s, n) => s + n.checkedKcal, 0) / nutritionDays.length) : null
    const avgProtein = nutritionDays.length ? Math.round(nutritionDays.reduce((s, n) => s + n.checkedProtein, 0) / nutritionDays.length) : null

    const prsThisWeek = Object.entries(exercisePRs || {}).filter(([, pr]) => pr.dayNumber >= startDay && pr.dayNumber <= endDay)

    weeks.push({
      week: w,
      startDay,
      endDay,
      isCurrent: w === currentWeek,
      daysElapsed: dayNumbers.length,
      completedDays,
      adherence,
      weightChange,
      avgKcal,
      avgProtein,
      prNames: prsThisWeek.map(([name]) => name),
    })
  }

  return weeks
}
